import React from "react";

interface LeadMergeConfirmationProps {
    onSubmit: () => Promise<void>;
    setConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
}

export function LeadMergeConfirmation({ onSubmit,
    setConfirmation }: LeadMergeConfirmationProps) {
    return (
        <>
            <div
                className="modal fade show in"
                id="exampleModal"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{
                    zIndex: 9999,
                    background: '#00000047'
                }}
            >
                <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
                    <div className="modal-content rounded-0">
                        <div className="modal-body text-center">
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <p>Are you sure you want to merge the selected leads to the main lead ?</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-auto mr-auto">
                                        <button
                                            type="button"
                                            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                                            onClick={() => setConfirmation(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            type="submit"
                                            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                                            onClick={() => onSubmit()}
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}
